export enum ProfitGroupBy {
  COIN = 'COIN',
  BOT = 'BOT',
}
